export default {
  common: {
    chiller: "Flüssigkeitskühler",
    chilledWaterPump: "Kaltwasserpumpe",
    coolingTower: "Kühlturm",
    nextStep: "Nächster Schritt",
    previousStep: "Vorheriger Schritt",
    objective: "Zielsetzung",
    preRetrofit: "Vor der Modernisierung",
    postRetrofit: "Nach der Modernisierung",
    retrofitSetup: "Modernisierungssetup",
    equipmentRated: "Gerätebewertung",
    equipmentConfig: "Geräte und Konfiguration",

    retrofitSummary: "Modernisierungsübersicht",
    cwp: "CWP",
    condenderWaterPump: "Kühlwasserpumpe des Verflüssigers",
    chwp: "CHWP",
    ct: "CT",
    other: "Sonstige",
    otherEquipment: "Sonstige Geräte",
    chillerOneNos: "Flüssigkeitskühler (1 Stück)",
    condenderWaterPumpOneNos: "Kühlwasserpumpe des Verflüssigers (1 Stück)",
    chilledWaterPumpOneNos: "Kaltwasserpumpe (1 Stück)",
    coolingTowerFanOneNos: "Kühlturm (1 Stück)",
    controlOptimization: "Regelungsoptimierung",
    commonHeader: "Gemeinsame Sammelleitung",
    dedicatedOneOnOne: "Feste 1:1-Zuordnung",
    pleaseInput: "Bitte eingeben",
    pleaseEnterHere: "Bitte hier eingeben",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    years: "Jahre",
    noProjectInfo: "Keine Projektinformationen",
    pleaseInputData: "Bitte Daten eingeben",
    systemOptionRequired: "Systemoption ist erforderlich",
    proposedEquipmentRequired: "Vorgeschlagene Ausrüstung ist erforderlich",
    profileEquipmentSetting: "Geräteeinstellungen im Profil",
    Total: "Gesamt"
  },
  objective: {
    projectObjective: "Projektziel",
    chillerEfficiency: "Wirkungsgrad des Flüssigkeitskühlers",
    chillerPlantEfficiency: "Wirkungsgrad der Kältezentrale",
    heatingEfficiency: "Heizungswirkungsgrad",
    heatingPlantEfficiency: "Wirkungsgrad der Wärmezentrale",
    chillerHeatingEfficiency: "Kälte- und Heizungswirkungsgrad",
    pleaseSelectAProjectObjective: "Bitte wählen Sie ein Projektziel aus",
    oneOnOne: "1:1",
    oneOnOneOrPlant: "1:1 oder Gesamtanlage",
    projectName: "Aktuelles Projekt",
    doYouWantSave: "Möchten Sie Ihre Daten vor dem Schließen in der Cloud speichern?",
    start: "Start",
    quickNavigation: "Schnellnavigation",
    mainMenu: "Hauptmenü",

    establishBaseline: "Ausgangsbasis ermitteln (vor der Modernisierung)",
    profile: "Profil",
    siteObservation: "Feststellungen vor Ort",
    equipmentSpecification: "Technische Gerätedaten",
    baselineInput: "Eingaben zur Ausgangsbasis",
    summary: "Zusammenfassung",
    generateReport: "Bericht erstellen",

    finalizeYourProposal: "Lösungsoptionen (nach der Modernisierung)",
    finalizeAnalysis: "Analyse abschließen",
    retrofitSetup: "Modernisierung einrichten",
    equipmentConfig: "Geräte und Konfiguration",
    financialAnalysis: "Wirtschaftlichkeitsanalyse",
    proposedConfig: "Vorgeschlagene Konfiguration",
    systemOption: "Systemoption",
    ProfileEquipment: "Profil und Geräte",
    baselinePreview: "Vorschau der Ausgangsbasis",
    profileEquipment: "Profil und Geräte",
    selectProposedEquipments: "Vorgeschlagene Geräte auswählen",
    pleaseSelectEquipments: "Bitte wählen Sie Geräte aus.",

    clusterSetting: "Gruppeneinstellungen",
    generateOption: "Option erstellen",

    baselineConfig: "Konfiguration der Ausgangsbasis",
    monthlyBaseline: "Monatliche Ausgangsbasis"
  },
  setup: {
    systemOption: "Systemoption",
    chillerOnly: "Nur Flüssigkeitskühler",
    chillerWithAssociatedEquipment: "Flüssigkeitskühler mit zugehörigen Geräten",
    controlOnly: "Nur Regelung",
    proposedLayout: "Vorgeschlagenes Anlagenschema",
    series: "Serie",
    parallel: "Parallel",
    proposedEquipment: "Vorgeschlagene Geräte"
  },
  rated: {
    newEquipment: "Gerät hinzufügen",
    ratedInputPower: "Nennleistungsaufnahme",
    ratedCoolingCapacity: "Nennkälteleistung",
    chillerLabel: "Flüssigkeitskühlerkennzeichnung",
    type: "Typ",
    chillerBrandModel: "Marke und Modell des Flüssigkeitskühlers",
    yearInstalled: "Installationsjahr",
    ratedDesignFlowRate: "Nennvolumenstrom (Auslegungsvolumenstrom)",
    pressureHead: "Förderhöhe",
    vfd: "Ist ein Frequenzumrichter installiert?",
    yes: "Ja",
    no: "Nein",
    noofFansCT: "Anzahl der Ventilatoren je Kühlturm",
    equipmentLabel: "Gerätekennzeichnung",
    category: "Kategorie",
    brand: "Marke",
    otherEquipment: "Sonstige Geräte",
    inputEcatPerformanceData: "e-CAT-Leistungsdaten eingeben",
    load: "Last",
    coolingLoad: "Kühllast",
    inputPower: "Leistungsaufnahme",
    chillerWaterPumpLabel: "Kaltwasserpumpenkennzeichnung",
    ratedMotorFrequency: "Nennfrequenz des Motors",
    minimumMotorFrequency: "Minimale Motorfrequenz",
    motor: "Motor",
    applicableChiller: "Geeigneter Flüssigkeitskühler",
    condenserWaterPumpLabel: "Kennzeichnung der Kühlwasserpumpe des Verflüssigers",
    coolingTowerLabel: "Kühlturmkennzeichnung",
    ratedFanFrequency: "Nennfrequenz des Ventilators",
    minimumFanFrequency: "Minimale Ventilatorfrequenz",
    totalRatedFanPowerPerCT: "Gesamte Ventilatornennleistung je Kühlturm",
    heatRejectionCapacityPerCT: "Wärmeabfuhrleistung je Kühlturm",
    chillerLabelRequired: "Flüssigkeitskühlerkennzeichnung ist erforderlich",
    yellowBlockRequired: "Der gelbe Bereich ist ein Pflichtfeld",
    labelRequired: "Kennzeichnung ist erforderlich",
    maximumQuantity: "Maximale Anzahl",

    chilledWaterSupplyTemp: "Kaltwassereintrittstemperatur",
    outdoorAirTemp: "Außenlufttemperatur",

    condenserWaterSupplyTemp: "Kühlwassereintrittstemperatur am Verflüssiger",

    singleChillerSellingPrice: "Verkaufspreis je Flüssigkeitskühler",
    singleCHWPSellingPrice: "Verkaufspreis je Kaltwasserpumpe",
    singleCWPSellingPrice: "Verkaufspreis je Kühlwasserpumpe des Verflüssigers",
    singleCTSellingPrice: "Verkaufspreis je Kühlturm",

    singlePrice: "Stückverkaufspreis"
  },
  summary: {
    chooleYourPreference: "Wählen Sie Ihre Präferenz aus",
    higherEfficiencyImprovement: "Höhere Wirkungsgradsteigerung",
    lowerInvestment: "Geringere Investition",
    higherCostSaving: "Höhere Kosteneinsparung",
    shorterPaybackPeriod: "Kürzere Amortisationszeit",
    option: "Option",
    efficiencyImprovement: "Wirkungsgradsteigerung",
    returnOnInvestment: "Kapitalrendite (ROI)",
    costSavingsPerYear: "Kosteneinsparungen pro Jahr",
    paybackPeriod: "Amortisationszeit",
    optionDetails: "Optionsdetails",
    postRetrofitEfficiency: "Wirkungsgrad nach der Modernisierung",
    totalEnergySavingsPerYear: "Gesamte Energieeinsparungen pro Jahr",
    investmentAnalysis: "Investitionsanalyse (Istwerte)",
    capex: "CAPEX",
    sellingPrice: "Verkaufspreis",
    OverallProjectPrice: "Gesamtprojektpreis",
    chillerCooling: "Flüssigkeitskühler – Kühlbetrieb",
    chillerHeatPump: "Flüssigkeitskühler/Wärmepumpe",
    calculate: "Berechnen",
    proposedConfig: "Vorgeschlagene Konfiguration",
    projectIntroduction: "Projektvorstellung",
    assumptions: "Annahmen",
    chillerPlant: "Kältezentrale",
    chillerPlantConfig: "Konfiguration der Kältezentrale",
    peakBuildingCoolingLoad: "Maximale Gebäudekühllast",
    designChilledWaterSupplyTemp: "Auslegungs-Kaltwassereintrittstemperatur",
    designCondenserWaterSupplyTemp: "Auslegungs-Kühlwassereintrittstemperatur am Verflüssiger",
    energyConservationMeasures: "Energieeinsparmaßnahmen",
    pumpingConfig: "Pumpenkonfiguration",
    designFlowRate: "Auslegungsvolumenstrom",
    designPressureHead: "Auslegungsförderhöhe",
    vfdFitted: "Mit Frequenzumrichter ausgestattet",
    chillerConfig: "Flüssigkeitskühlerkonfiguration",
    condenserWaterPump: "Kühlwasserpumpe des Verflüssigers",
    coolingTowerConfig: "Kühlturmkonfiguration",
    heatRejectionCapacity: "Wärmeabfuhrleistung",
    designCoolingTowerApproach: "Auslegungs-Kühlgrenzabstand des Kühlturms",
    generateReport: "Bericht erstellen",
    confirmCalculation: "Berechnung bestätigen",
    doYouNeedCalculationAgain: "Das Berechnungsergebnis ist bereits vorhanden. Möchten Sie neu berechnen?",
    recalculate: "Neu berechnen",
    coolingTower: "Kühlturm",
    chiller: "Flüssigkeitskühler",
    chilledWaterPump: "Kaltwasserpumpe",
    fillValidNumericalValue: "Bitte geben Sie einen gültigen Zahlenwert ein",

    runningNumber: "Anzahl betriebener Geräte"
  },
  profileMap: {
    associatedCT: "Zugeordneter Kühlturm",
    associatedCWP: "Zugeordnete Kühlwasserpumpe des Verflüssigers",
    associatedCHWP: "Zugeordnete Kaltwasserpumpe",
    profileId: "Profil-ID",
    donotNeedmanipulate: "Im automatischen Modus müssen Sie die Profile nicht bearbeiten.",

    automatic: "Automatisch",
    manual: "Manuell",
    pathAndMethod: "Pfad und Methode",
    months: "Monate",
    running: "In Betrieb",
    daysPerMonth: "Tage / Monat",
    chiller: "Flüssigkeitskühler"
  }
  // reportFocusDlg: {
  //   selectCustomerReportingFocus: "Schwerpunkt des Kundenberichts auswählen",
  //   roiLedSummary: "ROI-orientierte Zusammenfassung",
  //   roiLedSummaryDetails: "Verwenden, wenn Investitionskosten, Einsparungen und Amortisationszeit verfügbar sind.",
  //   efficiencyImprovementLedSummary: "Zusammenfassung mit Fokus auf Effizienzsteigerung",
  //   efficiencyImprovementLedSummaryDetails: "Verwenden, wenn die Entscheidungsfindung hauptsächlich auf Energieeffizienz basiert oder ROI-Daten nicht verfügbar bzw. nicht aussagekräftig sind."
  // }
}



// WEBPACK FOOTER //
// ./src/locale/post/de.js